import Papa from "papaparse";
import ttl2jsonld from "@frogcat/ttl2jsonld";
const N3 = require("n3");
const { DataFactory } = N3;
const { namedNode, literal, quad } = DataFactory;

export const readLocalCSV = async (file) => {
  if (!file) {
    return [];
  }
  return new Promise((resolve) => {
    Papa.parse(file, {
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
    });
  });
}

export const readRemoteCSV = async (url) => {
  if(!url) {
    return [];
  }
  const data = await downloadStream(url);
  return new Promise((resolve) => {
    Papa.parse(data, {
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
    });
  });
}

const downloadStream = async function(urlString){
  const url = new URL(urlString)
  const response = await fetch(url, {
      method: 'GET'
    }).catch((err) => {
      console.log(err)
      return err
    })
  if(response.ok) {
      return response.body
  } else {
      throw new Error()
  }
}

export const readUploadCSV = async (inputFiles) => {
  const file = inputFiles[0];
  if (!file) {
    return [];
  }

  const promise1 = new Promise((resolve) => {
    Papa.parse(file, {
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
    });
  });

  const file2 = inputFiles[1];
  if (!file2) {
    const result = await Promise.all([promise1]);
    return result;
  }

  const promise2 = new Promise((resolve) => {
    Papa.parse(file2, {
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
    });
  });

  // ファイルを読み込めたら作成開始
  const [res1, res2] = await Promise.all([promise1, promise2]);
  return [res1, res2];
};

export const createJsonLd = async (res) => {
  // headerを消す
  const baseVoc = res[0].slice(1);
  const words = res[1].slice(1);
  // prefix作成
  const prefixes = {
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    skos: "http://www.w3.org/2004/02/skos/core#",
    dct: "http://purl.org/dc/terms/",
  };
  prefixes[baseVoc[0][2]] = baseVoc[0][3];
  //this.$set(prefixes, baseVoc[0][2], baseVoc[0][3]);

  // 語彙基本情報について
  const basicInfo = [
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
      namedNode("http://www.w3.org/2004/02/skos/core#ConceptScheme")
    ),
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://purl.org/dc/terms/title"),
      literal(baseVoc[0][0], "ja")
    ),
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://purl.org/dc/terms/title"),
      literal(baseVoc[0][1], "en")
    ),
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://purl.org/dc/terms/description"),
      literal(baseVoc[0][4], "ja")
    ),
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://purl.org/dc/terms/description"),
      literal(baseVoc[0][5], "en")
    ),
    quad(
      namedNode(baseVoc[0][3]),
      namedNode("http://purl.org/dc/terms/creator"),
      literal(baseVoc[0][6])
    ),
  ];

  // 他の辞書について出てきたときに投入する用の配列
  const otherVocablaries = [];

  // 各ワード用の配列
  const glossary = [];

  // 代表語URIが等しいものでまとめる
  const newList = [];
  for (const term of words) {
    const idx = newList.findIndex((v) => v[0][3] === term[3]);
    if (idx === -1) {
      newList.push([term]);
    } else {
      newList[idx].push(term);
    }
  }

  // 代表語URIごとに実行
  for (const sameUri of newList) {
    const representUri = sameUri[0][3];

    const inSheme = representUri.slice(
      0,
      representUri.lastIndexOf("/") + 1
    );

    glossary.push(
      quad(
        namedNode(representUri),
        namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
        namedNode("http://www.w3.org/2004/02/skos/core#Concept")
      ),
      quad(
        namedNode(representUri),
        namedNode("http://www.w3.org/2004/02/skos/core#inScheme"),
        namedNode(inSheme)
      )
    );

    // 代表語
    const prefList = [
      ...new Set(sameUri.map((v) => JSON.stringify([v[1], v[2]]))),
    ].map(JSON.parse);

    for (const pref of prefList) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#prefLabel"),
          literal(pref[0], pref[1])
        )
      );
    }

    // 用語名
    // 代表語と一致するものを取り除く
    const altList = sameUri.filter((v) => v[0] !== v[1]);
    for (const alt of altList) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#altLabel"),
          literal(alt[0], alt[2])
        )
      );
    }

    // 自身を上位語として使用したURI
    const narrowList = newList
      .filter((v) => v[0][4] === representUri)
      .map((w) => w[0][3]);

    for (const narrow of narrowList) {
      const narrowTemp = narrow.slice(0, narrow.lastIndexOf("/") + 1);
      if (
        Object.keys(prefixes).find((key) => prefixes[key] === narrowTemp)
      ) {
        glossary.push(
          quad(
            namedNode(representUri),
            namedNode("http://www.w3.org/2004/02/skos/core#narrower"),
            namedNode(narrow)
          )
        );
      } else {
        glossary.push(
          quad(
            namedNode(representUri),
            namedNode("http://www.w3.org/2004/02/skos/core#narrowMatch"),
            namedNode(narrow)
          )
        );
      }
    }

    // 上位語URI
    const broad = sameUri[0][4].slice(
      0,
      sameUri[0][4].lastIndexOf("/") + 1
    );
    const isMyVoc = Object.keys(prefixes).find(
      (key) => prefixes[key] === broad
    );
    if (
      isMyVoc &&
      Object.keys(prefixes).find(
        (key) =>
          prefixes[key] ===
          representUri.slice(0, representUri.lastIndexOf("/") + 1)
      )
    ) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#broader"),
          namedNode(sameUri[0][4])
        )
      );
    } else {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#broadMatch"),
          namedNode(sameUri[0][4])
        )
      );

      if (!otherVocablaries.find((v) => v === broad) && !isMyVoc) {
        otherVocablaries.push(broad);
      }
    }

    // 同義語URI
    if (sameUri[0][5]) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#exactMatch"),
          namedNode(sameUri[0][5])
        )
      );

      const exact = sameUri[0][5].slice(
        0,
        sameUri[0][5].lastIndexOf("/") + 1
      );
      if (!otherVocablaries.find((v) => v === exact)) {
        otherVocablaries.push(exact);
      }
    }

    // 用語の説明
    const descriptionList = [
      ...new Set(
        sameUri.filter((u) => u[6]).map((v) => JSON.stringify([v[6], v[2]]))
      ),
    ].map(JSON.parse);

    for (const description of descriptionList) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://www.w3.org/2004/02/skos/core#description"),
          literal(description[0], description[1])
        )
      );
    }

    // 作成日
    if (sameUri[0][7]) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://purl.org/dc/terms/created"),
          literal(sameUri[0][7])
        )
      );
    }

    // 最終更新日
    if (sameUri[0][8]) {
      glossary.push(
        quad(
          namedNode(representUri),
          namedNode("http://purl.org/dc/terms/modified"),
          literal(sameUri[0][8])
        )
      );
    }
  }

  const otherVocablariesNodes = [];
  for (const vocablaryName of otherVocablaries) {
    otherVocablariesNodes.push(
      quad(
        namedNode(vocablaryName),
        namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
        namedNode("http://www.w3.org/2004/02/skos/core#ConceptScheme")
      )
    );
  }

  const quadLists = basicInfo.concat(otherVocablariesNodes, glossary);

  return new Promise((resolve, reject) => {
    const writer = new N3.Writer({ prefixes: prefixes });
    for (const namedNodes of quadLists) {
      writer.addQuad(namedNodes);
    }
    writer.end((error, result) => {
      if (error) {
        reject(error);
      }
      const jsonld = convertJsonld(result);
      resolve(jsonld);
    });
  });
};

// JSON-LDに変換
const convertJsonld = async (result) => {
  return await ttl2jsonld.parse(result);
};
